import React, { FC, useState } from "react";
import { Modal, Row, Col, Collapse } from "antd";
import _ from "lodash";
import { Form, Input, Button } from "antd";
import { FormLabel } from "react-bootstrap";
import {
  ArrowLeftOutlined,

  CloseOutlined,
} from "@ant-design/icons";
import { ReactSVG } from "react-svg";


const OutgoingModal: FC<{
  onClose: () => void;
  phoneNumber: string;
  setPhoneNumber: any;
  handleChange: any;
  callOutgoing: any;
}> = ({ onClose, phoneNumber, setPhoneNumber, handleChange, callOutgoing }) => {
  const [isModalVisible, setIsModalVisible] = useState<boolean>(true);
  const [confirmation] = Form.useForm();
  const [loading, setLoading] = useState<boolean>(false);

  const handleCancel = () => {};

  return (
    <Modal
      title="Call Dialer"
      visible={true}
      onCancel={handleCancel}
      width="480px"
      className="beam-modal"
      footer={[]}
      destroyOnClose={true}
      closable={false}
    >
      <React.Fragment>
                        {/* <Row className="d-flex mt-1 mb-4">
                          <Col>
                            <h2>Add participant</h2>
                          </Col>
                        </Row> */}
                        <Row className="d-flex mt-4 w-100">
                          <Col span={24}>
                            <Input
                              className="beam-input"
                              value={phoneNumber}
                              onChange={(e) => {
                                // console.log("e", e.target.value);
                                if (
                                  e.target.value.match(/^[0-9+]+$/) !== null ||
                                  e.target.value === ""
                                ) {
                                  setPhoneNumber(e.target.value);
                                }
                              }}
                            />
                          </Col>
                        </Row>
                        <Row className="d-flex mt-4 w-100">
                          {_.times(9, (idx) => (
                            <Col span={8} className="d-flex mb-3">
                              <Button
                                className="beam-btn round-btn m-auto mb-4"
                                style={{ minWidth: 50, minHeight: 50 }}
                                key={idx}
                                onClick={() => handleChange(idx + 1)}
                              >
                                {idx + 1}
                              </Button>
                            </Col>
                          ))}
                        </Row>
                        <Row className="d-flex w-100">
                          <Col span={8} className="d-flex mb-3">
                            <Button
                              className="beam-btn round-btn m-auto mb-4"
                              onClick={() => handleChange("+")}
                              style={{ minWidth: 50, minHeight: 50 }}
                            >
                              +
                            </Button>
                          </Col>
                          <Col span={8} className="d-flex mb-3">
                            <Button
                              className="beam-btn round-btn m-auto mb-4"
                              style={{ minWidth: 50, minHeight: 50 }}
                              onClick={() => handleChange("0")}
                            >
                              0
                            </Button>
                          </Col>
                          <Col span={8} className="d-flex mb-3">
                            <Button
                              className="beam-btn round-btn m-auto mb-4"
                              style={{ minWidth: 50, minHeight: 50 }}
                              onClick={() => handleChange("#")}
                            >
                              #
                            </Button>
                          </Col>
                        </Row>
                        <Row className="d-center mt-3 w-100">
                          <Col span={8} className="d-flex">
                            <Button
                              className="beam-btn m-auto"
                              style={{ minWidth: 50, minHeight: 50 }}
                              onClick={() => {
                                // setAddParticipant(false);
                                setPhoneNumber("");
                                onClose();
                              }}
                            >
                              <CloseOutlined />
                            </Button>
                          </Col>
                          <Col span={8} className="d-flex">
                            <Button
                              className="beam-btn round-btn cover call-btn m-auto"
                              style={{ minWidth: 50, minHeight: 50 }}
                              onClick={() => {
                                // handleAddParticipant();
                                callOutgoing({
                                  output: {
                                    activeCallerPhoneNumber: phoneNumber
                                  },
                                })
                                setPhoneNumber("");
                                onClose();
                              }}
                            >
                              <ReactSVG src="/images/call-icon.svg" />
                            </Button>
                          </Col>
                          <Col span={8} className="d-flex">
                            <Button
                              className="beam-btn m-auto"
                              style={{ minWidth: 50, minHeight: 50 }}
                              onClick={() => handleChange(null)}
                            >
                              <ArrowLeftOutlined />
                            </Button>
                          </Col>
                        </Row>
                      </React.Fragment>
    </Modal>
  );
};

export default OutgoingModal;
